enum StatusDaAutorizacaoDeOpmeEnum {
  Autorizado = 'Autorizado,',
  JustificarEmConta = 'JustificarEmConta,',
  NaoAutorizado = 'NaoAutorizado,',
  NegociacaoParticular = 'NegociacaoParticular,',
}

export default StatusDaAutorizacaoDeOpmeEnum
